/**
 * ROLES CONSTANTS
 * 
 * Define a estrutura de permissões e as colunas da tabela de Cargos.
 */

import { GLOBAL_STATUS, GLOBAL_STATUS_LABELS } from "../../../constants/common";;

export const ROLE_COLUMNS = [
    { key: "name", label: "Nome do Cargo" },
    { key: "description", label: "Descrição" },
    { key: "status", label: "Status", render: (row) => GLOBAL_STATUS_LABELS[row.status] || 'Desconhecido' }, // Usaremos StatusBadge depois
    { key: "updatedAt", label: "Última Atualização" },
];

export const PERMISSION_GROUPS = [
    {
        name: "Dashboards",
        permissions: [
            { id: "dashboards_manager_view", label: "Acesso ao Dashboard Gerencial" },
            { id: "dashboards_financial_view", label: "Acesso ao Dashboard Financeiro" },
        ]
    },
    {
        name: "Operacional",
        permissions: [
            { id: "grade_manage", label: "Gerenciar Grade de Aulas" },
            { id: "members_manage", label: "Gerenciar Clientes (CRM, Trial, Listagem)" },
            { id: "kiosk_access", label: "Acesso ao Quiosque" },
            { id: "management_evaluation_run", label: "Lançar Avaliações" },
        ]
    },
    {
        name: "Metodologia & Treinos",
        permissions: [
            { id: "methodology_planning", label: "Criar Planejamento de Aulas" },
            { id: "admin_activities", label: "Configurar Atividades" },
            { id: "management_evaluation_levels", label: "Gerenciar Níveis de Avaliação" },
            { id: "admin_events", label: "Configurar Eventos Avaliativos" },
            { id: "management_training_manage", label: "Criar Treinos" },
        ]
    },
    {
        name: "Financeiro",
        permissions: [
            { id: "financial_cashier", label: "Operar Caixa (PDV)" },
            { id: "financial_cashflow", label: "Acesso Analítico Financeiro (Fluxo e Contas)" },
            { id: "financial_acquirers", label: "Configurar Adquirentes" },
            { id: "admin_memberships", label: "Gerenciar Venda de Planos" },
        ]
    },
    {
        name: "Administrativo & Gerencial",
        permissions: [
            { id: "employees_manage", label: "Gerenciar Colaboradores (Equipe)" },
            { id: "admin_portfolio", label: "Gerenciar Carteira de Alunos" },
            { id: "admin_areas", label: "Configurar Áreas / Locais" },
            { id: "admin_roles", label: "Configurar Cargos e Permissões" },
            { id: "admin_catalog", label: "Gerenciar Catálogo de Produtos" },
            { id: "admin_classes", label: "Gerenciar Turmas" },
            { id: "management_audit_log", label: "Visualizar Logs de Auditoria" },
        ]
    },
    {
        name: "Configurações do Sistema",
        permissions: [
            { id: "settings_company_manage", label: "Configuração da Empresa" },
            { id: "settings_gamification", label: "Configurar Gamificação" },
            { id: "management_integrations", label: "Gerenciar Integrações" },
            { id: "management_automations", label: "Configurar Automações" },
            { id: "settings_import", label: "Importação de Dados Massiva" }
        ]
    }
];


/**
 * Retorna os cargos predefinidos para um novo cliente corporativo.
 * Pode ser injetado durante a criação do tenant (Seed) ou na Cloud Function.
 */
export const getDefaultRoles = () => {
    // Helper para gerar um objeto true/false de permissões baseando-se nos IDs
    const buildPermissions = (allowedKeys = 'ALL') => {
        const perms = {};
        PERMISSION_GROUPS.forEach(group => {
            group.permissions.forEach(p => {
                if (allowedKeys === 'ALL') {
                    perms[p.id] = true;
                } else {
                    perms[p.id] = allowedKeys.includes(p.id);
                }
            });
        });
        return perms;
    };

    return [
        {
            name: "Gestor",
            description: "Administrador da unidade. Possui acesso total.",
            status: GLOBAL_STATUS.ACTIVE,
            permissions: buildPermissions('ALL') // Tudo ligado para o Gestor local
        },
        {
            name: "Coordenador",
            description: "Coordena a parte técnica e treinos, sem acesso financeiro ou de configuração global.",
            status: GLOBAL_STATUS.ACTIVE,
            permissions: buildPermissions([
                // Dashboards
                'dashboards_manager_view',
                // Operacional
                'grade_manage', 'members_manage',
                // Metodologia e Treinos
                'methodology_planning', 'management_evaluation_run',
                'admin_activities', 'management_evaluation_levels',
                'admin_events', 'management_training_manage',
                // Financeiro (nada)
                // Administrativo
                'employees_manage', 'admin_classes', 'admin_portfolio', 'admin_catalog'
                // Configurações (nada)
            ])
        },
        {
            name: "Professor",
            description: "Pode ver turmas, alunos e realizar testes e avaliações.",
            status: GLOBAL_STATUS.ACTIVE,
            permissions: buildPermissions([
                'grade_manage', 'members_manage',
                'management_evaluation_run', 'management_training_manage',
                'kiosk_access'
            ])
        },
        {
            name: "Recepcionista",
            description: "Foca no atendimento ao cliente, caixa, vendas e CRM.",
            status: GLOBAL_STATUS.ACTIVE,
            permissions: buildPermissions([
                'grade_manage', 'members_manage', 'kiosk_access',
                'financial_cashier', 'admin_memberships'
            ])
        }
    ];
};
